module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5r9n3r-19d36cd8eb9d015806936cee10c27584.svg";